import { Component, Show } from "solid-js";

interface RecordingStatusProps {
  status: "recording" | "paused" | "completed" | "failed" | null;
  duration?: number;
}

const RecordingStatus: Component<RecordingStatusProps> = (props) => {
  const formatDuration = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div class="flex items-center gap-2">
      <Show when={props.status === "recording"}>
        <div class="flex items-center gap-2">
          <div class="w-2 h-2 rounded-full bg-red-500 animate-pulse"></div>
          <span class="text-sm text-red-600 font-medium">Recording</span>
          <Show when={props.duration !== undefined}>
            <span class="text-sm text-gray-500">
              ({formatDuration(props.duration!)})
            </span>
          </Show>
        </div>
      </Show>

      <Show when={props.status === "paused"}>
        <div class="flex items-center gap-2">
          <div class="w-2 h-2 rounded-full bg-yellow-500"></div>
          <span class="text-sm text-yellow-600 font-medium">Paused</span>
        </div>
      </Show>

      <Show when={props.status === "completed"}>
        <div class="flex items-center gap-2">
          <div class="w-2 h-2 rounded-full bg-green-500"></div>
          <span class="text-sm text-green-600 font-medium">
            Recording Saved
          </span>
        </div>
      </Show>

      <Show when={props.status === "failed"}>
        <div class="flex items-center gap-2">
          <div class="w-2 h-2 rounded-full bg-red-500"></div>
          <span class="text-sm text-red-600 font-medium">Recording Failed</span>
          <button
            class="text-xs text-blue-600 hover:text-blue-800 underline"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </Show>
    </div>
  );
};

export default RecordingStatus;
